<div class="modal-overlay" (click)="close.emit()">
  <div class="modal-card" style="max-width: 600px; width: 90%; max-height: 90vh; overflow-y: auto;" (click)="$event.stopPropagation()">
    <div class="modal-header-gradient">
      <div class="modal-title-row">
        <h5>Create Notification</h5>
      </div>
      <button class="modal-close-btn" (click)="close.emit()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="modal-body p-4" [formGroup]="notificationForm">
      <div class="form-grid">
        <!-- Title -->
        <div class="form-field">
          <label class="field-label">Title</label>
          <input pInputText formControlName="title" placeholder="Enter notification title" class="w-full"
            [class.ng-invalid]="isInvalid('title')" [class.ng-dirty]="isInvalid('title')" />
          @if (isInvalid('title')) {
          <small class="field-error">{{ getError('title') }}</small>
          }
        </div>

        <!-- Delivery Type -->
        <div class="form-field">
          <label class="field-label">Delivery Type</label>
          <p-select formControlName="deliveryType" [options]="deliveryTypeOptions" optionLabel="label" optionValue="value"
            optionDisabled="disabled" placeholder="Select Delivery Type" class="w-full"
            [class.ng-invalid]="isInvalid('deliveryType')" />
          @if (isInvalid('deliveryType')) {
          <small class="field-error">{{ getError('deliveryType') }}</small>
          }
        </div>
      </div>

      <!-- Audience -->
      <div class="form-field mt-3">
        <label class="field-label">Audience</label>
        <p-select formControlName="audience" [options]="audienceOptions" optionLabel="label" optionValue="value"
          placeholder="Select audience" class="w-full audience-select" [class.ng-invalid]="isInvalid('audience')" />
        @if (isInvalid('audience')) {
        <small class="field-error">{{ getError('audience') }}</small>
        }
      </div>

      <!-- Single User: email/phone field -->
      @if (isSingleUser) {
      <div class="form-field mt-3">
        <label class="field-label">{{ isSms ? 'Mobile Number' : 'Email Address' }}</label>

        @if (isSms) {
        <div class="d-flex gap-2 align-items-center w-full">
          <p-select formControlName="countryCode" [options]="countryCodes" optionLabel="label" optionValue="value"
            [filter]="true" filterBy="label" class="country-code-dropdown" style="width: 140px; margin-top: 0;"
            [class.ng-invalid]="isInvalid('countryCode')">
            <ng-template #selectedItem let-selectedOption>
              <div class="d-flex align-items-center gap-2">
                <img [src]="selectedOption.flag"
                  style="width: 20px; height: 14px; object-fit: cover; border-radius: 2px;" />
                <span>{{ selectedOption.value }}</span>
              </div>
            </ng-template>
          </p-select>
          <input pInputText formControlName="singleUserContact" placeholder="Enter mobile number" style="flex: 1;"
            [class.ng-invalid]="isInvalid('singleUserContact')" [class.ng-dirty]="isInvalid('singleUserContact')"
            (keypress)="onlyNumbers($event)" />
        </div>
        } @else {
        <input pInputText formControlName="singleUserContact" placeholder="Enter email address" class="w-full"
          [class.ng-invalid]="isInvalid('singleUserContact')" [class.ng-dirty]="isInvalid('singleUserContact')" />
        }

        @if (isInvalid('singleUserContact')) {
        <small class="field-error">{{ getError('singleUserContact') }}</small>
        }
      </div>
      }

      <!-- Early Release Users: date picker -->
      @if (isEarlyRelease) {
      <div class="form-field mt-3">
        <label class="field-label">Release Date</label>
        <input type="date" formControlName="releaseDate" class="w-full date-input"
          [class.ng-invalid]="isInvalid('releaseDate')" />
        @if (isInvalid('releaseDate')) {
        <small class="field-error">{{ getError('releaseDate') }}</small>
        }
      </div>
      }

      <!-- Message -->
      <div class="form-field mt-3">
        <label class="field-label">Message</label>
        <textarea pTextarea formControlName="message" placeholder="Enter Notification Message" rows="4"
          class="w-full message-textarea" [class.ng-invalid]="isInvalid('message')"
          [class.ng-dirty]="isInvalid('message')"></textarea>
        @if (isInvalid('message')) {
        <small class="field-error">{{ getError('message') }}</small>
        }
      </div>
    </div>

    <div class="modal-footer d-flex justify-content-end gap-2 p-3 border-top">
      <p-button label="Cancel" severity="secondary" (onClick)="close.emit()" />
      <p-button label="Send Notification" icon="pi pi-send" [loading]="sending" (onClick)="sendNotification()" class="send-btn" />
    </div>
  </div>
</div>
